interface UseLocalStorageReturn<T> {
	isAvailable: boolean
	getCurrentValue(): T
	clearCurrentValue(): void
	setValue(newValue: T): void
}

export const useLocalStorage = <T>(key: string, defaultValue: T): UseLocalStorageReturn<T> => {
	const isAvailable = typeof window !== 'undefined' && typeof localStorage !== 'undefined'

	const clearCurrentValue = () => {
		if (isAvailable) localStorage.removeItem(key)
	}
	const setValue = (value: T) => {
		if (!isAvailable) return
		if (!value) clearCurrentValue()
		else localStorage.setItem(key, JSON.stringify(value))
	}
	const getCurrentValue = () => {
		if (!isAvailable) return defaultValue
		const stringValue = localStorage.getItem(key)
		return stringValue ? JSON.parse(stringValue || `${defaultValue}`) : defaultValue
	}

	return { isAvailable, clearCurrentValue, setValue, getCurrentValue }
}
